import type { EventListQuery, SafeEvent } from "@playarena/shared";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { EventState } from "../../types/event";

const initialState: EventState = {
  events: [],
  selectedEvent: null,
  filters: {},
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 12,
    hasNextPage: false,
    hasPrevPage: false,
  },
  isLoading: false,
  error: null,
};

const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<EventListQuery>) => {
      state.filters = action.payload;
    },
    clearFilters: state => {
      state.filters = {};
    },
    setSelectedEvent: (state, action: PayloadAction<SafeEvent | null>) => {
      state.selectedEvent = action.payload;
    },
    clearError: state => {
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setPagination: (state, action: PayloadAction<EventState["pagination"]>) => {
      state.pagination = action.payload;
    },
    setEvents: (state, action: PayloadAction<SafeEvent[]>) => {
      state.events = action.payload;
    },
    addEvent: (state, action: PayloadAction<SafeEvent>) => {
      state.events.unshift(action.payload);
    },
    updateEventInList: (state, action: PayloadAction<SafeEvent>) => {
      const index = state.events.findIndex(event => event.id === action.payload.id);
      if (index !== -1) {
        state.events[index] = action.payload;
      }
    },
    removeEventFromList: (state, action: PayloadAction<string>) => {
      state.events = state.events.filter(event => event.id !== action.payload);
    },
  },
});

export const {
  setFilters,
  clearFilters,
  setSelectedEvent,
  clearError,
  setLoading,
  setError,
  setPagination,
  setEvents,
  addEvent,
  updateEventInList,
  removeEventFromList,
} = eventSlice.actions;
export default eventSlice.reducer;
